'use strict';

const { getDeviceType } = require('../utils');
var base = require('./base');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,
    // addToCart: base.addToCart,
    images: base.images,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available);

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },
    initStickyNav: function () {
        var $navElement = $('#pdp-product-nav');
        var $navElementLength = $navElement.find('.nav-link').length;
        if ($navElement.hasClass('init-sticky-nav')) {
            $navElement.closest('.experience-dynamic-productNav').addClass('sticky-top');
            if (getDeviceType() === 'Mobile' && $navElementLength > 3) {
                $navElement.slick();
                $navElement.css('overflow-x', 'hidden');
            }
        }

        // pdp how to use nav sticky feature
        
        if ($('body').find('.page-redesign').length > 0){
            window.addEventListener("scroll", function() {
                var stickytopPdpTop = $('.experience-region.experience-productDetailBottom').offset().top
                var footerTop = $('footer').offset().top;
                var currentScrollTop = window.scrollY;
                var headerHeight = 136 + 100;
                var stickyTopExpected = stickytopPdpTop - headerHeight;
                if ((currentScrollTop >= (stickyTopExpected)) && currentScrollTop < (footerTop - 200)){
                    $('.experience-component.experience-dynamic-productNav.sticky-top').addClass('fixedTopNav');
                } else {
                    $('.experience-component.experience-dynamic-productNav.sticky-top').removeClass('fixedTopNav');
                }
            });
            $('.pdp-product-nav.init-sticky-nav .btn.nav-link').on('click', function(event){
                event.preventDefault();
                var targetElement = $(this.getAttribute('href'));
                var targetPosition = targetElement.offset().top - 180;
                $('html, body').animate({
                    scrollTop: targetPosition
                }, 500);
            });
        }
        
    },
    navigateToNavItem: function () {
        $(window).on('activate.bs.scrollspy', function () {
            var $activeNavItem = $('.nav-link.active');
            var index = $activeNavItem.closest('.slick-slide').data('slick-index');
            if (index >= 0) {
                $activeNavItem.closest('.pdp-product-nav').slick('slickGoTo', index);
            }
        });
    },
    hideEmptyCarousels: function () {
        var $carouselElement = $('.hide-carousel-and-nav');
        $carouselElement.each(function () {
            // hide the link to the carousel in the nav
            $('[data-linked-element=' + $(this).attr('id') + ']').addClass('found-and-hid');
            // it's not enough to hide the carousel, since there can be a background image component around it,
            // we need to hide the ancestor that is a direct child of the "experience-productDetailBottom" element
            var $carouselElementToHide = $(this);
            // get direct children of the experience-productDetailBottom element, hide the one that contains the empty carousel
            $('.experience-productDetailBottom').children().each(function () {
                var $directChildOfProductDetailBottom = $(this);
                if ($directChildOfProductDetailBottom.has($carouselElementToHide).length) {
                    $directChildOfProductDetailBottom.addClass('hide-highest-level-component');
                }
            });
        });
    },
    removeEmptySlide: function () {
        if ($('.experience-commerce_layouts-ingredientsCarousel .pd-slider').length) {
            var self = $('.experience-commerce_layouts-ingredientsCarousel .pd-slider');
            var slides = self.find('.slick-slide');

            slides.each(function () {
                var currentSlide = $(this);

                if (currentSlide.find('.ingredient-thumbnail-container').length === 0) {
                    // currentSlide.remove();
                    self.slick('slickRemove', currentSlide.index());
                }
            });

            self.closest('.pd-slider').slick('unslick');
            document.querySelectorAll('.product.pd-slide').forEach(slide => {
                if (!slide.querySelector('.ingredient-thumbnail-container')) {
                    slide.remove();
                }
            });
            self.closest('.pd-slider').slick();
        }
    },
    updateAponowButton: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (response && response.data && response.data.aponowButton) {
                // aponowButton is an html string created by a template rendering of aponowBuyNowButton.isml
                $('.find-in-store-container').html(response.data.aponowButton);
            }
        });
    },
    jsGaldermaME: function () {
        $('.Galderma-ME .pdp-main .short-desc p').each(function (idx, attr) {
            if ($(attr).text().indexOf('•') !== -1) {
                var updatedText = $(attr).text().replace('•', '-');
                $(attr).text(updatedText);
            }
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
